/* START GENAI@GHCOPILOT */

export default function createSessionId() {
  return crypto.randomUUID();
}
/* END GENAI@GHCOPILOT */
